import React, { useState } from 'react'
import { useLoaderData } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { usePacienteAntecedentes } from './hooks/usePacienteAntecedentes';
import { useDatosGenerales } from './hooks/useDatosGenerales';

import { PacienteAntecedentesPreview } from './components/PacienteAntecedentesPreview';
import { PacienteAntecedentesUpdate } from './components/PacienteAntecedentesUpdate';
import { Error, Forbidden, Loader } from '../../components';

export async function loader({ params }) {
  return params.id;
}

export const PacienteAntecedentes = () => {

  const id = useLoaderData();

  const { permisos } = useSelector(state => state.auth);

  const { pacienteAntecedentesQuery: { isLoading: isLoadingPacienteAntecedentes, isError: isErrorPacienteAntecedentes, data: pacienteAntecedentes } } = usePacienteAntecedentes(id);

  const { datosGeneralesQuery: { isLoading: isLoadingConfiguracionDatosGenerales, isError: isErrorConfiguracionDatosGenerales, data: configuracionDatosGenerales } } = useDatosGenerales();

  const [antecedentesUpdateStatus, setAntecedentesUpdateStatus] = useState(false);

  return (permisos.antecedentesRead || permisos.antecedentesUpdate) ? (
    <>
      {(isLoadingPacienteAntecedentes || isLoadingConfiguracionDatosGenerales)
        ? <Loader />
        : <>
            {(isErrorPacienteAntecedentes || isErrorConfiguracionDatosGenerales)
            ? <Error />
            : <>
              {(antecedentesUpdateStatus && permisos.antecedentesUpdate)
              ? <PacienteAntecedentesUpdate configuracionDatosGenerales={configuracionDatosGenerales} paciente={id} pacienteAntecedentes={pacienteAntecedentes} handleCancelarEditarPacienteAntecedentes={() => setAntecedentesUpdateStatus(false)} />
              : <PacienteAntecedentesPreview configuracionDatosGenerales={configuracionDatosGenerales} pacienteAntecedentes={pacienteAntecedentes} handleEditarPacienteAntecedentes={() => setAntecedentesUpdateStatus(true)} />
              }
            </>
          }
        </>
      }
    </>
  ) : <Forbidden />
}